// extracted by mini-css-extract-plugin
module.exports = {"link":"PinLink_link__V3tHN"};